import React, { useState } from "react";
import classes from "../styles.module.scss";
import {
  BurgerClosedIcon,
  BurgerIcon,
  ChevronRightIcon,
  Logo,
  LogoutIcon,
  MenuToggleIcon,
  SettingsIcon,
  UserIcon,
} from "../../../../assets/icons";
import i18n from "../../../../i18n";
import Search from "./search.component";
import Current from "./current.component";
import Navbar from "./navbar.component";
import Photos from "./photos.component";
import Akim from "./akim.component";
import { Info } from "./info.component";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../../contexts/user.context";
import { useNavigate, useParams } from "react-router-dom";
import keycloak from "../../../../keycloak/keycloak";

const languages = [
  { code: "ru", label: "Рус" },
  { code: "kz", label: "Қаз" },
];

const LeftMenu = () => {
  const { t } = useTranslation();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [language, setLanguage] = useState(i18n.language);
  const { user } = useUser();
  const navigate = useNavigate();
  const { kato } = useParams<{ kato: string }>();
  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
    setLanguage(langCode);
  };

  const toggleMenu = () => {
    console.log("menu toggled");
  };

  const openSettings = () => {
    navigate(`/${kato}/settings`);
  };

  const navigateToAdmin = () => {
    navigate(`/admin`);
  };

  return (
    <div className={classes.menu}>
      <div
        className={`${classes.menu__header} ${
          isLoginOpen ? classes["menu__header--open"] : ""
        }`}
      >
        <div className={classes.menu__top}>
          <div className={classes.menu__burger}>
            {isLoginOpen ? (
              <BurgerClosedIcon onClick={() => setIsLoginOpen(false)} />
            ) : (
              <BurgerIcon onClick={() => setIsLoginOpen(true)} />
            )}
          </div>

          <Logo className={classes.menu__logo} />
          <div className={classes.menu__lang}>
            {languages.map((lang) => (
              <span
                key={lang.code}
                className={`
                                ${classes.menu__lang__item} 
                                ${
                                  lang.code === language
                                    ? classes["menu__lang__item--active"]
                                    : ""
                                }`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                {lang.label}
              </span>
            ))}
          </div>
          <div className={classes.menu__burger}>
            <MenuToggleIcon onClick={toggleMenu} />
          </div>
        </div>
        {!isLoginOpen && (
          <>
            <Search />
            <Current />
          </>
        )}
      </div>

      <div
        className={classes.menu__body}
        style={{
          maxHeight: !isLoginOpen ? "calc(100vh - 11.9375rem)" : "unset",
        }}
      >
        {isLoginOpen ? (
          <div className={classes.menu__login}>
            <div className={classes.menu__login__user}>
              <div className={classes.menu__login__username}>
                <UserIcon />
                {user?.preferred_username}
              </div>
              <button onClick={navigateToAdmin}>
                {t("actions.to-admin")}{" "}
              </button>
              <button onClick={() => keycloak.logout()}>
                {t("actions.logout")} <LogoutIcon />
              </button>
            </div>
            {user?.isAdmin && <div
              className={classes.menu__login__settings}
              onClick={openSettings}
            >
              <div className={classes.menu__login__icon}>
                <SettingsIcon />
              </div>
              <span>{t("settings")}</span>
              <div className={classes.menu__login__icon}>
                <ChevronRightIcon />
              </div>
            </div>}
            <div className={classes.menu__login__info}>
              <a
                href="https://adilet.zan.kz/rus/docs/V15C0004686"
                target="_blank"
                rel="noreferrer"
              >
                {t("rules")}
              </a>
            </div>
          </div>
        ) : (
          <>
            <Navbar />
            <Photos />
            <Akim />
            <Info />
          </>
        )}
      </div>
    </div>
  );
};

export default LeftMenu;
